import { Injectable } from '@angular/core';
import { Gtp } from '../../gtp';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PuntosService {
  puntosCliente = <any>[];
  puntosClienteObs = new Subject<any>();
  
  constructor(
    private gtp: Gtp,
    private http: HttpClient,
  ) {

  }

  /**
   * Trae los puntos de cliente
   */
  getPuntosClienteObs(){
    return this.puntosClienteObs.asObservable();
  }
  /**
   * Trae los puntos de cliente
   */
   setPuntosClienteObs(obj){
    this.puntosCliente = obj;
    this.puntosClienteObs.next(obj);

  }

  /**
   * Listado de grupos de puntos
   */
  getGrupos(puntos=false){
    const showpuntos = (puntos) ? '?puntos=true' : '';
    const url = `${environment.baseUrl}inforef/gruposreferencias${showpuntos}`;
    return this.http.get(url);
  }

  /**
   * Listado de Tipo de puntos
   */
  getTipoPuntos(){
    const url = `${environment.baseUrl}inforef/tipospuntos`;
    return this.http.get(url);
  }

  /**
   * Listado de Paises
   */
  getPais(){
    const url = `${environment.baseUrl}inforef/pais`;
    return this.http.get(url);
  }

  /**
   * Listado de Íconos
   */
  getIconos(){
    const url = `${environment.baseUrl}inforef/iconos`;
    //console.log(url);
    return this.http.get(url);
  }

  addPunto(params){
    var body = {
        nombre: params.descripcion,
        id_pais: parseFloat(params.pais),
        latitud: params.latitud,
        longitud: params.longitud,
        id_icono: params.icono.idIcono,
        grupo_id: (params.grupo != '') ? params.grupo : null ,
        tipo_punto_id: parseFloat(params.tipopunto),
        radio: params.radio,
    };
    return this.http.post(`${environment.baseUrl}inforef/puntosgrados`, body);
  }
  
  deletePunto(gid){
    return this.http.delete(`${environment.baseUrl}inforef/puntosgrados/`+ gid);

  }
}

/*

Creacion de punto
curl --request POST \
  --url https://gtpmovil.com/apirastreo/v1/inforef/puntosgrados/ \
  --header 'authorization: Bearer :token' \
  --header 'content-type: application/json' \
  --data '{
"nombre": "Prueba API ÑA",
"id_pais": 1,
"latitud": -25.3326895,
"longitud": -57.6116609,
"id_icono": 4,
"grupo_id": 142,
"tipo_punto_id": 3,
"radio": 5
}'

Para id_pais
curl --request GET \
  --url https://gtpmovil.com/apirastreo/v1/inforef/pais/ \
  --header 'authorization: Bearer :token' \
  --header 'content-type: application/json' \
  --data '{

}'

Para id_icono
curl --request GET \
  --url https://gtpmovil.com/apirastreo/v1/inforef/iconos/ \
  --header 'authorization: Bearer :token' \
  --header 'content-type: application/json' \
  --data '{

}'

Para grupo_id
curl --request GET \
  --url https://gtpmovil.com/apirastreo/v1/inforef/gruposreferencias/ \
  --header 'authorization: Bearer :token' \
  --header 'content-type: application/json' \
  --data '{

}'

Para tipo_punto_id
curl --request GET \
  --url https://gtpmovil.com/apirastreo/v1/inforef/tipospuntos/ \
  --header 'authorization: Bearer :token' \
  --header 'content-type: application/json' \
  --data '{

}'

*/